import React, { useEffect, useState } from 'react';
import {
    Box, Dialog, DialogContent, DialogTitle, IconButton,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const VisagedFilesPopup = ({ open, onClose, fileIds, caseFiles, deletedCaseFiles }) => {
    const [filteredFiles, setFilteredFiles] = useState([]);

    useEffect(() => {
        const parsedFileIds = fileIds.split(',').map(id => parseInt(id)).filter(id => id);

        const files = parsedFileIds.map(id =>
            caseFiles.find(file => file.id === id) ||
            deletedCaseFiles.find(file => file.id === id)
        ).filter(Boolean);

        setFilteredFiles(files);
    }, [open, fileIds, caseFiles, deletedCaseFiles]);


    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <IconButton onClick={onClose} edge="end" aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>დოკუმენტის ნომერი</TableCell>
                                <TableCell>დოკუმენტის სახელი</TableCell>
                                <TableCell>შემქნნელი</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredFiles.map((file) => (
                                <TableRow key={file.id}>
                                    <TableCell>{file.documentNumber}</TableCell>
                                    <TableCell>{file.name}</TableCell>
                                    <TableCell>{file.fullname}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default VisagedFilesPopup;
